import Table from 'components/grid/table/table';
import TableFields from 'components/grid/table/components/fields';
import Empty from 'components/grid/table/components/empty';
import Actions from 'components/grid/table/components/actions';
import Action from 'components/grid/table/components/actions/components/action';

export const TableComponents = {
  ...TableFields,
  Empty,
  Actions,
  Action,
};

export default Object.assign(Table, TableComponents);
